import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { useGraphStore } from "../graph";
import { useSymbolsStore } from "../symbols";

let graphStore: ReturnType<typeof useGraphStore>;
let symbolsStore: ReturnType<typeof useSymbolsStore>;
function init() {
	graphStore = useGraphStore();
	symbolsStore = useSymbolsStore();
}

export const useAlternisStore = defineStore("alternis", () => {
	const isExpanded = ref();
	const clickedHighlightAttributes = ref<string[]>([]);
	const clickedHighlightWord = ref<string>("");

	const MY_MESSAGE = "#4db6ac";
	const USER_MESSAGE = "#80808044";

	function cleanedString(text: string): string {
		return text.toLowerCase().replace(/[^a-z0-9äöüÄÖÜßçış]/g, "");
	}

	const highlights = computed(() => {
		if (!graphStore || !symbolsStore) init();
		// TODO: maybe consider datatype enum items in the future asswell
		let h: {
			[attrId: string]: {
				[lang: string]: {
					term: string;
					synonyms: string[];
					dataobjectTerm: string;
					dataobjectSynonyms: string[];
				};
			};
		} = {};
		graphStore.instance.attributes.forEach((attr) => {
			let concept = graphStore.concept.attribute.byId(attr.concept);
			if (!concept) return;
			if (concept.hide) return;
			let langs = symbolsStore.languages;
			h[attr.id] = {};
			langs.forEach((lang) => {
				let term = symbolsStore.term({ id: concept?.refersTo, terminology: concept?.terminology });
				let synonyms = symbolsStore.synonyms({
					id: concept?.refersTo,
					terminology: concept?.terminology,
					lang: lang,
				});
				let conceptDataobject = graphStore.concept.dataobject.byId(concept?.partOf || "");
				let dataobjectTerm = symbolsStore.term({
					id: conceptDataobject?.refersTo,
					terminology: conceptDataobject?.terminology,
				});
				let dataobjectSynonyms = symbolsStore.synonyms({
					id: conceptDataobject?.refersTo,
					terminology: conceptDataobject?.terminology,
					lang: lang,
				});

				h[attr.id][lang] = {
					term: term,
					synonyms: synonyms,
					dataobjectTerm: dataobjectTerm,
					dataobjectSynonyms: dataobjectSynonyms,
				};
			});
		});
		return h;
	});

	return {
		isExpanded,
		clickedHighlightAttributes,
		clickedHighlightWord,
		MY_MESSAGE,
		USER_MESSAGE,
		cleanedString,
		highlights,
	};
});
